import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomCheckbox } from '../../constants/custom-checkbox';

@Component({
  selector: 'custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  standalone: true,
  imports: [TranslateModule, FormsModule, CommonModule],
  styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent {
  @Input() items: CustomCheckbox[] = [];
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  select(flag: boolean, item: CustomCheckbox) {
    this.onSelect.emit(this.items);
  }
}
